import { useCosmicLocalizationContext } from '@taxbit-private/cosmic-localization'
import dayjs, { extend } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useCallback } from 'react'

extend(utc)

export const canonical = (addr: string) =>
  addr.startsWith('0x') || addr.startsWith('0X') ? addr.toLowerCase() : addr

export const round = (num: number, places: number) => {
  return Math.round((num + Number.EPSILON) * 10 ** places) / 10 ** places
}

export function useLimitToTwoDecimalPlaces() {
  const { locale } = useCosmicLocalizationContext()

  return useCallback(
    (number: number | string) =>
      Intl.NumberFormat(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        useGrouping: false,
      }).format(Number.parseFloat(number.toString())),
    [locale]
  )
}

/*
  It doesn't look like there is an easy way to specify timezone for the AntD
  date picker today (https://github.com/ant-design/ant-design/issues/11012),
  so we have to manually force the chosen time to be at the start of the day
  in UTC.
*/
export const getUTCtime = (date: string | number | Date | null) => {
  return date ? dayjs.utc(date).startOf('day') : undefined
}
